/**
 * API Configuration
 * Centralized configuration for API endpoints and base URL
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api";

export const API_ENDPOINTS = {
  LINKEDIN_POSTS: `${API_BASE_URL}/linkedin/posts`,
  CONTACT_US: `${API_BASE_URL}/email/contact-us`,
  APPLY: `${API_BASE_URL}/email/apply`,
};

export default API_BASE_URL;
